var youbora = require('youboralib')
var manifest = require('../manifest.json')

youbora.adapters.HbbtvHtml5 = youbora.Adapter.extend({
  /** Override to return current plugin version */
  getVersion: function () {
    return manifest.version + '-' + manifest.name + '-' + manifest.tech
  },

  /** Override to return current playhead of the video */
  getPlayhead: function () {
    return this.player.playPosition / 1000
  },

  /** Override to return video duration */
  getDuration: function () {
    return this.player.playTime / 1000
  },

  /** Override to return resource URL. */
  getResource: function () {
    return this.player.src
  },

  /** Override to return player's name */
  getPlayerName: function () {
    return "Hbbtv"
  },

  /** Register listeners to this.player. */
  registerListeners: function () {
    // Enable playhead monitor (buffer = true, seek = false)
    this.monitorPlayhead(true, true)
    this.player.onPlayStateChange = function (e) {
      this.playStateChangeListener()
    }.bind(this)
    this.states = [
      'STOPPED', // 0
      'PLAYING', // 1
      'PAUSED', // 2
      'CONNECTING', // 3
      'BUFFERING', // 4
      'FINISHED', // 5
      'ERROR' // 6
    ]
  },

  playStateChangeListener: function () {
    youbora.Log.debug("Play State: " + this.states[this.player.playState] + ":" + this.player.playState)
    switch (this.player.playState) {
      case 0:
        this.fireStop()
      case 1:
        this.fireResume()
        this.fireSeekEnd()
        this.fireJoin()
        break
      case 2:
        this.firePause()
        break
      case 3:
      case 4:
        this.fireStart()
        break
      case 5:
        this.fireStop()
        break
      case 6:
        this.fireError()
        break
    }
  }
})

module.exports = youbora.adapters.HbbtvHtml5



//////////////////
// WEBPACK FOOTER
// ./src/adapter.js
// module id = 26
// module chunks = 0